/** Mobile-first `sizes` hints aligned with site.css breakpoints (480 / 768 / 900). */
export const SITE_IMAGE_SIZES = {
  heroSplit: '(max-width: 899px) 100vw, 50vw',
  heroFullBleed: '100vw',
  heroMonolithSeal: '120px',
  heroPedestal: '(max-width: 479px) 88vw, 420px',
  heroReveal: '(max-width: 899px) 100vw, 55vw',
  heroZineMain: '(max-width: 479px) 78vw, 420px',
  heroZineDetail: '(max-width: 479px) 42vw, 200px',
  menuBanner: '100vw',
  /** Contact map — full width on a phone, half the page beside the facts. */
  contactMap: '(max-width: 899px) 100vw, 50vw',
  menuCategory: '(max-width: 899px) 100vw, 42vw',
  menuDishCard: '(max-width: 479px) 100vw, (max-width: 899px) 46vw, 32vw',
  /** Highlight promenade plates — tall cards in a horizontal rail. */
  menuHighlightPlate: '(max-width: 479px) 78vw, (max-width: 899px) 42vw, 28vw',
  menuHighlightHero: '(max-width: 899px) 100vw, 58vw',
  menuHighlightZine: '(max-width: 479px) 70vw, 280px',
  menuHighlightToday: '100vw',
  chefPortrait: '(max-width: 899px) 100vw, 360px',
  /** Philosophy note — full note width on a phone, a 7.5rem square from 768px. */
  chefNote: '(max-width: 767px) 92vw, 120px',
  /** Team lead / pass photo — full width on a phone, half the band on desktop. */
  kitchenTeamLead: '(max-width: 899px) 100vw, 42vw',
  /** Team row portrait — roughly a quarter of the board on desktop. */
  kitchenTeamMember: '(max-width: 479px) 46vw, (max-width: 899px) 30vw, 18vw',
  /** Salon photo — full width until the 900px split beside the inquiry card. */
  partySalon: '(max-width: 899px) 100vw, 42vw',
  galleryMosaicLead: '(max-width: 479px) 100vw, (max-width: 899px) 100vw, 46vw',
  galleryMosaicCell: '(max-width: 479px) 100vw, (max-width: 899px) 46vw, 24vw',
  /** Column masonry — roughly one third of the board on desktop. */
  galleryMasonry: '(max-width: 479px) 100vw, (max-width: 899px) 46vw, 32vw',
  galleryFilmstrip: '(max-width: 479px) 78vw, (max-width: 899px) 42vw, 28vw',
  gallerySpotlight: '(max-width: 899px) 100vw, 72vw',
  galleryThumb: '88px',
  galleryLedger: '(max-width: 767px) 100vw, 56vw',
  galleryLightbox: '92vw',
  heroVideo: '100vw',
} as const;
